/* eslint-disable camelcase */
import { EnvConfigType, AmplifyConfigType } from './ConfigType';

// sub環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint: 'https://a9rg7o7pti.execute-api.ap-northeast-1.amazonaws.com/sub',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint: 'https://yr3noeltm2.execute-api.ap-northeast-1.amazonaws.com/sub',
      region: 'ap-northeast-1',
    },
  ],
};

const config: EnvConfigType = {
  env: 'sub',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG',
  analyticsTrackingId: 'G-4Z66V2XF1G', // local用
  inquiryFormUrl: 'about:blank',
  viewerEndpoint: '',
  lpInquiryFormUrl: 'about:blank',
  ymPublishedBibliograpyUrl: 'about:blank',
  siteDomain: 'sub.manabi.poplar.co.jp',
  adminUrl: 'https://admin.sub.manabi.poplar.co.jp',
  yomokkaUrl: 'https://yomokka.sub.manabi.poplar.co.jp',
  sagasokkaUrl: 'https://sagasokka.sub.manabi.poplar.co.jp',
  mottosokkaUrl: 'https://sub.manabi.poplar.co.jp',
  sso: {
    redirectPath: '/loading',
    idpConfig: {
      microsoft: {
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        clientId: 'fbd9ca6e-419d-4c08-ad53-09296ef51c27',
        clientSecret: '', // microsoftでは使用しない
        scope: ['openid', 'profile', 'email', 'User.Read'],
      },
      google: {
        authorizationEndpoint: '', // googleでは使用しない
        clientId: '417912956025-64p1i3cu046hao2b45mn1eevjkbfm41r.apps.googleusercontent.com',
        clientSecret: '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',
        scope: ['openid', 'profile', 'email'],
      },
    },
  },
  maintenanceInfoUrl: 'https://sub.manabi.poplar.co.jp/maintenance/info.txt',
  maintenanceExpiryUrl: 'https://sub.manabi.poplar.co.jp/maintenance/expiry.txt',
};

export default config;
